import React,{useEffect,useState} from 'react'
// import './PageTitle.less'
import {Modal} from 'antd'
const Index=()=>{
    const[visible,setVisible] = useState(true);
    const[secondsToGo,setSecondsToGo] = useState(5);
    const handleOk = e => {
        console.log(e);
        setVisible(false);
      };
    
      const handleCancel = e => {
        setVisible(false);
      };
      useEffect(()=>{
        let tm=setTimeout(() => {
            if(secondsToGo>0){
              setSecondsToGo((c:number)=>{
                  return c-1;
              });
            }else{
                setVisible(false);
                clearTimeout(tm)  
            }
        }, 1000);
        return ()=>{
          clearTimeout(tm)  
        }
      },[secondsToGo]);
      
    return (
     <Modal
        title="温馨提示"
        centered
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={300}
        footer={null}
    >
        <div className="tipContent" ><p>平安产险消费者权益保护温馨提示，您即将进入投保流程：请仔细阅读保险条款、投保须知等内容，以保障自身的权益。为保障您的权益，您在销售页面的操作将会被记录并加密存储，同时页面输入的信息将仅用于投保</p><p className="msbox">{secondsToGo}s</p></div>
    </Modal> 
    )
}


export default Index
